const DATE_FORMAT_URL = /^\d{4}-\d{2}-\d{2}$/;

/**
 * Parses a search URL and extracts search parameters.
 * Handles both one-way and round-trip URL formats, including open-ticket variants:
 * - One-way:       /search/{origin}/{dest}/{departure}/p/{passengers}/...
 * - Round-trip:    /search/{origin}/{dest}/{departure}/{return}/p/{passengers}/...
 * - Open-ticket:   /search/{origin}/{dest}/{departure}/p/{passengers}/departures/open
 *                  /search/open-ticket/{origin}/{dest}/{departure}/{return}/
 * - Open return:   ...?returnIsOpenTicket=true
 *
 * @param {string} pathname - URL pathname
 * @param {string} [queryString] - URL query string (e.g. "?returnIsOpenTicket=true")
 * @returns {{ originSlug: string, destinationSlug: string, departureDate: string, returnDate: string|null, passengersStr: string|null, isDepartureOpen: boolean, isReturnOpen: boolean } | null}
 */
function parseSearchUrl(pathname, queryString = '') {
  const parts = pathname.split('/').filter(Boolean);

  if (parts[0] !== 'search' || parts.length < 4) return null;

  let isDepartureOpen = false;
  let isReturnOpen = false;
  let offset = 1;

  // /search/open-ticket/origin/dest/... route
  if (parts[1] === 'open-ticket') {
    isDepartureOpen = true;
    offset = 2;
    if (parts.length < 5) return null;
  }

  const originSlug = parts[offset];
  const destinationSlug = parts[offset + 1];
  const departureDate = parts[offset + 2];
  const rest = parts.slice(offset + 3);

  let returnDate = null;
  let passengersStr = null;

  if (DATE_FORMAT_URL.test(rest[0])) {
    // rest: [returnDate, 'p', passengers, ...]
    [returnDate, , passengersStr] = rest;
  } else {
    // rest: ['p', passengers, ...]
    [, passengersStr] = rest;
  }

  // /departures/open suffix in the regular route
  if (parts.includes('open')) {
    isDepartureOpen = true;
  }

  // Return open ticket via query param
  if (queryString && new URLSearchParams(queryString).get('returnIsOpenTicket') === 'true') {
    isReturnOpen = true;
  }

  return {
    originSlug,
    destinationSlug,
    departureDate,
    returnDate,
    passengersStr,
    isDepartureOpen,
    isReturnOpen,
  };
}

export default parseSearchUrl;
